import React from 'react';
import './brandsCarousel.css';

// SVG Logos for top-tier companies
// SVG Logos for top-tier companies
const LOGOS = [
  {
    name: 'Google',
    svg: (
      <svg viewBox="0 0 16 16" width="30" height="30" fill="currentColor">
        <path d="M15.545 6.558a9.4 9.4 0 0 1 .139 1.626c0 2.434-.87 4.492-2.384 5.885h.002C11.978 15.292 10.158 16 8 16A8 8 0 1 1 8 0a7.7 7.7 0 0 1 5.352 2.082l-2.284 2.284A4.35 4.35 0 0 0 8 3.166c-2.087 0-3.86 1.408-4.492 3.304a4.8 4.8 0 0 0 0 3.063h.003c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.004-.276 2.722-.764h-.003a3.7 3.7 0 0 0 1.599-2.431H8v-3.08z" />
      </svg>
    )
  },
  {
    name: 'Microsoft',
    svg: (
      <svg viewBox="0 0 23 23" width="32" height="32" fill="currentColor">
        <path d="M0 0h11v11H0zM12 0h11v11H12zM0 12h11v11H0zM12 12h11v11H12z" />
      </svg>
    )
  },
  {
    name: 'Amazon',
    svg: (
      <svg viewBox="0 0 16 16" width="30" height="30" fill="currentColor">
        <path d="M10.813 11.968c.157.083.36.074.5-.05l.005.005a90 90 0 0 1 1.623-1.405c.173-.143.143-.372.006-.563l-.125-.17c-.345-.465-.673-.906-.673-1.791v-3.3l.001-.335c.008-1.265.014-2.421-.933-3.305C10.404.274 9.06 0 8.03 0 6.017 0 3.77.75 3.296 3.24c-.047.264.143.404.316.443l2.054.22c.19-.009.33-.196.366-.387.176-.857.896-1.271 1.703-1.271.435 0 .929.16 1.188.55.264.39.26.91.257 1.376v.432q-.3.033-.621.065c-1.113.114-2.397.246-3.36.67C3.873 5.91 2.94 7.08 2.94 8.798c0 2.2 1.387 3.298 3.168 3.298 1.506 0 2.328-.354 3.489-1.54l.167.246c.274.405.456.675 1.047 1.166ZM6.03 8.431C6.03 6.627 7.647 6.3 9.177 6.3v.57c.001.776.002 1.434-.396 2.133-.336.595-.87.961-1.465.961-.812 0-1.286-.619-1.286-1.533M.435 12.174c2.629 1.603 6.698 4.084 13.183.997.28-.116.475.078.199.431C13.538 13.96 11.312 16 7.57 16 3.832 16 .968 13.446.094 12.386c-.24-.275.036-.4.199-.299z"/>
        <path d="M13.828 11.943c.567-.07 1.468-.027 1.645.204.135.176-.004.966-.233 1.533-.23.563-.572.961-.762 1.115s-.333.094-.23-.137c.105-.23.684-1.663.455-1.963-.213-.278-1.177-.177-1.625-.13l-.09.009q-.142.013-.233.024c-.193.021-.245.027-.274-.032-.074-.209.779-.556 1.347-.623"/>
      </svg>
    )
  },
  {
    name: 'Deloitte',
    svg: (
      <svg viewBox="0 0 100 24" width="95" height="24" fill="currentColor">
        <text x="0" y="17" fontFamily="Arial, Helvetica, sans-serif" fontWeight="900" fontSize="18" letterSpacing="-0.5px">Deloitte</text>
        <circle cx="70" cy="14.5" r="2.8" fill="#86BC25" />
      </svg>
    )
  },
  {
    name: 'Accenture',
    svg: (
      <svg viewBox="0 0 100 24" width="95" height="24" fill="currentColor">
        <text x="0" y="17" fontFamily="Arial, Helvetica, sans-serif" fontWeight="700" fontSize="16.5" letterSpacing="-0.5px">accenture</text>
        <path d="M80 6l4.5 4.5-4.5 4.5h3.2l4.5-4.5-4.5-4.5h-3.2z" fill="#A100FF" />
      </svg>
    )
  }
];

const BrandsCarousel = () => {
  // Duplicate logos list to make infinite scroll seamless
  const doubleLogos = [...LOGOS, ...LOGOS, ...LOGOS];

  return (
    <div className="brands-carousel">
      <p className="brands-carousel-title">Trusted by students and alumni working at</p>
      <div className="brands-carousel-track-wrapper">
        <div className="brands-carousel-track">
          {doubleLogos.map((logo, idx) => (
            <div className="brands-logo-item" key={idx} title={logo.name}>
              {logo.svg}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandsCarousel;
